import {Image, View, Text} from "react-native";

function LogoTitle (props) {
    return(
        <View style={{flexDirection:'row',alignItems:'center'}}>
            <Image source={props.logo} style={{width: 100,height: 50,resizeMode:'contain'}} />
            <Text style={{color: props.color,fontFamily:'Raleway',fontSize:'x-large',fontWeight:'bold'}}>{props.title}</Text>
        </View>
    )
}

export default LogoTitle